import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { NumberRange } from './number-range.model';

const HOST = environment.pumpDataUrl;

@Injectable({
  providedIn: 'root'
})
export class NumberRangeService {

  constructor(private http: HttpClient) { }

  getAll(): Observable<NumberRange[]> {
    return this.http.get<NumberRange[]>(`${HOST}numberranges`);
  }

  get(key: string): Observable<NumberRange> {
    return this.http.get<NumberRange>(`${HOST}numberrange/${encodeURIComponent(key)}`);
  }

  create(numberRange: NumberRange): Observable<NumberRange> {
    return this.http.post<NumberRange>(`${HOST}numberrange`, numberRange);
  }

  update(numberRange: NumberRange): Observable<NumberRange> {
    const { key, ...body } = numberRange;
    return this.http.put<NumberRange>(`${HOST}numberrange/${encodeURIComponent(key)}`, body);
  }

  increment(key: string): Observable<NumberRange> {
    return this.http.patch<NumberRange>(`${HOST}numberrange/${encodeURIComponent(key)}/increment`, {});
  }

  delete(key: string): Observable<string> {
    // Backend returns a plain text message
    return this.http.delete(`${HOST}numberrange/${encodeURIComponent(key)}`, { responseType: 'text' });
  }
}
